<div class="dialog">
    <div class="dialog-title">
        <h4 class="semi-bold">Record Payment <img src="assets/svg/close-white.svg" alt="close" (click)="close()"></h4>
    </div>
    <div class="content custom-form row mr-0 ml-0">
        <div class="col-md-6">
            <div class="row mr-0 ml-0 border-right">
                <div class="col-md-6">
                    <p class="regular mb-3">PO No:</p>
                </div>
                <div class=" col-md-6 pl-0">
                    <p class="semi-bold mb-2 ">{{poData?.vendor_order_code}}</p>
                </div>
                <div class="col-md-6">
                    <p class="regular mb-3">INVOICE No:</p>
                </div>
                <div class=" col-md-6 pl-0">
                    <p class="semi-bold mb-2">{{poData?.vendor_own_code ? poData?.vendor_own_code : ''}}</p>
                </div>
                <div class="col-md-6">
                    <p class="regular mb-3">BALANCE DUE:</p>
                </div>
                <div class=" col-md-6 pl-0">
                    <p class="medium mb-2 mb-0 orange-text">{{poData?.balance_due}}</p>
                </div>
                <div class="col-md-6">
                    <p class="regular mb-3">PAID AMOUNT:</p>
                </div>
                <div class=" col-md-6 pl-0">
                    <input class="mb-2" type="text" (focusout)="paidAmount($event.target.value)" [(ngModel)]="amount">
                </div>
                <div class="col-md-6">
                    <p class="regular mb-3">REMAIN AMOUNT</p>
                </div>
                <div class=" col-md-6 pl-0">
                    <p class="orange-text medium mb-0">{{remainingAmount? remainingAmount:'--'}}</p>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="file-drop primary-file-upload mt-3 mb-2">
                <form [formGroup]="demoForm">
                    <!-- <file-upload formControlName="files" accept=".pdf,.xls,.jpeg,.png">
                        <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder>
                            <span *ngIf="isFileDragDropAvailable">
                          <div _ngcontent-c1="" class="upload-input ng-trigger ng-trigger-zoomAnimation">
                            <div _ngcontent-c1="" class="icon ng-tns-c1-2 ng-star-inserted">
                                <svg _ngcontent-c1="" class="ng-tns-c1-2" viewBox="0 0 96 96">
                                <g _ngcontent-c1="" class="ng-tns-c1-2">
                                  <path _ngcontent-c1="" class="ng-tns-c1-2"
                                    d="M62.8,68.1c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6
                                     c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6s1.1-0.2,1.5-0.6S62.8,68.7,62.8,68.1z M71.3,68.1
                                     c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6C67.2,67,67,67.5,67,68.1c0,0.6,0.2,1.1,0.6,1.5
                                     s0.9,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6C71.1,69.2,71.3,68.7,71.3,68.1z M75.5,60.7v10.6c0,0.9-0.3,1.6-0.9,2.2
                                     c-0.6,0.6-1.4,0.9-2.2,0.9H23.7c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.4-0.9-2.2V60.7c0-0.9,0.3-1.6,0.9-2.2
                                     c0.6-0.6,1.4-0.9,2.2-0.9h14.1c0.5,1.2,1.2,2.2,2.3,3c1.1,0.8,2.3,1.2,3.7,1.2h8.5c1.3,0,2.6-0.4,3.7-1.2c1.1-0.8,1.9-1.8,2.3-3
                                     h14.1c0.9,0,1.6,0.3,2.2,0.9C75.2,59.1,75.5,59.8,75.5,60.7z M64.8,39.3c-0.4,0.9-1,1.3-2,1.3h-8.5v14.8c0,0.6-0.2,1.1-0.6,1.5
                                     c-0.4,0.4-0.9,0.6-1.5,0.6h-8.5c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5V40.6h-8.5c-0.9,0-1.6-0.4-2-1.3
                                     c-0.4-0.9-0.2-1.6,0.5-2.3l14.8-14.8c0.4-0.4,0.9-0.6,1.5-0.6s1.1,0.2,1.5,0.6L64.3,37C65,37.7,65.1,38.4,64.8,39.3z"></path>
                                </g>
                              </svg>
                              
                            </div>
                            <br>
                            <div class="upload-text mt-3  ng-tns-c1-2 ng-star-inserted">                                
                                <img class="pl-2" src="assets/svg/upload-file.svg" alt="cube">
                               <br>          
                                <div>                                      
                                    <b  class="center ng-tns-c1-2 ng-star-inserted">Upload Record Payment File</b>
                                <p style="text-decoration: none;">(Max Size up to 10MB)</p>
                                </div>
                            </div>
                          </div>
                        </span>
                            <span *ngIf="!isFileDragDropAvailable">click</span>
                        </ng-template>
                    </file-upload> -->


                    <file-upload formControlName="files" accept=".pdf,.xls,.jpeg,.png">
                        <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder>
                            <file-upload-drop-zone>
                                <ng-container *ngIf="isFileDragDropAvailable; else isNotDragDropAvailable">
                                    <b>Upload Record Payment File</b><br> (Max Size up to 10MB)
                                </ng-container>
                                <ng-template #isNotDragDropAvailable>
                                    <b>Click here to upload</b>
                                </ng-template>
                            </file-upload-drop-zone>
                        </ng-template>
                
                        <ng-template let-i="index" let-file="file" let-control="control" #item>
                            <file-upload-list-item  [index]="i" [file]="file" [control]="control">Remove</file-upload-list-item>
                        </ng-template>
                    </file-upload>
                </form>
            </div>
        </div>

    </div>

    <div class="button text-center">
        <button class="white mr-2" (click)="close()">Cancel</button>
        <button class="orange ml-2" (click)="submitPayment()">Submit</button>
    </div>
</div>